import { motion } from "framer-motion";
import { Zap, Video, UserCheck } from "lucide-react";

const FEATURES = [
  {
    icon: Zap,
    title: "Instant Matchmaking",
    desc: "Skip the scheduling. Get connected with another live sales rep in seconds and start practising immediately.",
    tag: "01",
  },
  {
    icon: Video,
    title: "Live Mock Calls",
    desc: "High-fidelity HD video roleplay with real objections and real pressure — the closest thing to being on a live prospect call.",
    tag: "02",
  },
  {
    icon: UserCheck,
    title: "Rep & Prospect Roles",
    desc: "Every match assigns a Rep and a Prospect automatically. Open the conversation one round, play the prospect the next — both seats make you sharper.",
    tag: "03",
  },
];

const card = {
  hidden: { y: 44, opacity: 0 },
  show: (i) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Features = () => {
  return (
    <section id="features" className="mx-auto max-w-7xl px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="mb-14 max-w-2xl"
      >
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E52525]">
          Why SalesPit
        </span>
        <h2 className="font-heading mt-4 text-3xl font-bold tracking-tight text-white md:text-4xl">
          Everything you need to train like the best sales reps.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              custom={i}
              variants={card}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#141414] p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-[#E52525]/30"
              data-testid={`feature-card-${i + 1}`}
            >
              <div
                aria-hidden="true"
                className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-[#E52525]/0 blur-2xl transition-colors duration-500 group-hover:bg-[#E52525]/20"
              />
              <span className="font-heading absolute right-7 top-6 text-sm font-bold text-white/10">
                {f.tag}
              </span>
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-[#E52525]/10 text-[#E52525]">
                <Icon size={22} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-white">
                {f.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-zinc-400">
                {f.desc}
              </p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
